import moment from 'moment';

const state = {
    tempDate: moment(),
    scheduleList: {
        expiredTs: null,
        openedTs: null,
        list: [],
    }
};

export default state;